import PageHead from "../Head";
import { withGuestSSR } from "@/lib/withGuestSSR";

import Context from "@/context/Context";
import Register from "@/my_components/_Register/Register";

const RegisterPage = () => {
  return (
      <Context>
        <PageHead title="Sign Up | SmartTech Academy" />

        <Register />
      </Context>
  );
};

export default RegisterPage;

export const getServerSideProps = withGuestSSR();
